import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';
import type { BetaDiscoverCard } from 'tio-employee/utils/beta/home-model';

/**
 * Shared inner markup for a discover card, so the internal-link, external-link,
 * and static wrappers below cannot drift apart.
 */
const CardBody: TOC<{
  Args: { card: BetaDiscoverCard };
}> = <template>
  <div class="tio-beta-home__discover-icon">
    {{#let @card.icon as |Icon|}}
      <Icon @size={{28}} />
    {{/let}}
  </div>

  <div class="tio-col-extra-tight">
    <div class="tio-beta-home__discover-title">{{@card.title}}</div>
    <div class="tio-beta-home__discover-copy">{{@card.description}}</div>
  </div>

  {{#if @card.meta}}
    <div class="tio-beta-home__discover-meta">{{@card.meta}}</div>
  {{/if}}
</template>;

/**
 * The design's repeating benefit card, used by all three grids: "Explore Your
 * Benefits" (new), "More to Explore" (active), and "Resources".
 *
 * 48px icon tile, title, description, and an optional meta line — Resources
 * cards omit the meta, which is what distinguishes them visually.
 */
const BetaHomeDiscoverCard: TOC<{
  Args: { card: BetaDiscoverCard };
}> = <template>
  {{#if @card.route}}
    <LinkTo
      @route={{@card.route}}
      class="tio-beta-home__discover"
      data-test-beta-discover={{@card.id}}
    >
      <CardBody @card={{@card}} />
    </LinkTo>
  {{else if @card.href}}
    <a
      href={{@card.href}}
      target="_blank"
      rel="noopener noreferrer"
      class="tio-beta-home__discover"
      data-test-beta-discover={{@card.id}}
    >
      <CardBody @card={{@card}} />
    </a>
  {{else}}
    <div class="tio-beta-home__discover" data-test-beta-discover={{@card.id}}>
      <CardBody @card={{@card}} />
    </div>
  {{/if}}
</template>;

export default BetaHomeDiscoverCard;
